module.exports = __webpack_public_path__ + "static/media/implant_promo_guy.24f51569.JPG";